import type { IconData } from '@stacksjs/iconify-core'

export const textSquare: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 496h480V16H16ZM48 48h416v416H48Z\"/><path fill=\"currentColor\" d=\"M112 176h32v-32h80v224h-32v32h128v-32h-32V144h80v32h32v-64H112z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default textSquare
